import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const posts = document.querySelectorAll('.experiences-grid__post')

posts.forEach(post => {
  
  let image = post.querySelector('.listed-experience__image')
  let image_mask = post.querySelector('.listed-experience__image-mask')
  let title = post.querySelector('.listed-experience__title')
  let excerpt = post.querySelector('.listed-experience__excerpt')
  let button = post.querySelector('.listed-experience__button-outer')
  
  if(window.innerWidth > 600){
    let post_timeline = gsap.timeline({
      scrollTrigger: {
        trigger: post,
        start: 'top center-=100',
        onEnter: () => {
          gsap.to(image, {opacity: 1, y: 0, duration: 0.5})
          gsap.to(image_mask, {scale: 1.0, duration: 1.5})
          gsap.to(title, {opacity: 1, x: 0, duration: 0.5})
          gsap.to(excerpt, {opacity: 1, x: 0, duration: 0.5})
          gsap.to(button, {opacity: 1, x: 0, duration: 0.5})
        }
      }
    })
  }else{
    gsap.to(image, {opacity: 1, y: 0, duration: 0})
    gsap.to(image_mask, {scale: 1.0, duration: 0})
    gsap.to(title, {opacity: 1, x: 0, duration: 0})
    gsap.to(excerpt, {opacity: 1, x: 0, duration: 0})
    gsap.to(button, {opacity: 1, x: 0, duration: 0})
  }
})

document.addEventListener("DOMContentLoaded", function () {
  //if (window.innerWidth > 600) {
    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (video) {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }
            video.target.load();
            video.target.classList.remove("lazy");
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });
      lazyVideos.forEach(function (lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    } else {
      for (var video in lazyVideos) {
        video = lazyVideos[video];
        for (var source in video.children) {
          var videoSource = video.children[source];
          if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
            videoSource.src = videoSource.dataset.src;
          }
        }
        video.load();
      }
    }
  //}
});